var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"material",attrs:{"draggable":"true"},on:{"mousedown":_vm.onMouseDown,"dragstart":_vm.onDragStart}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }